import { CLEAR_IMPERSONATION, SET_IMPERSONATION } from './ActionTypes';

export interface ImpersonationPayload {
  companyId: number | null;
  roleIds: number[];
}

export function setImpersonation(payload: ImpersonationPayload) {
  return {
    type: SET_IMPERSONATION,
    payload,
  };
}

export function clearImpersonation() {
  return {
    type: CLEAR_IMPERSONATION,
    payload: {},
  };
}

const ImpersonationAction = {
  setImpersonation,
  clearImpersonation,
};

export default ImpersonationAction;
